import React from 'react';
import Identicon from 'react-identicons';
import { useRouter } from 'next/router';

const DropAvatar = ({
  drop,
}: {
  drop: {
    dropID?: string;
    imageUrl?: string;
    imageUrlThumbnail?: string;
  };
}) => {
  const { push } = useRouter();

  const handleClick = (e) => {
    e.stopPropagation();
    if (drop?.dropID) {
      push(`/drop/${drop.dropID}`);
    }
  };
  return (
    <div
      role="presentation"
      className="drop-avatar-container"
      onClick={handleClick}
    >
      {drop?.imageUrl || drop?.imageUrlThumbnail ? (
        <img src={drop?.imageUrl || drop?.imageUrlThumbnail} alt="drop cover" />
      ) : (
        <Identicon string={drop?.dropID} size={40} />
      )}
    </div>
  );
};

export default DropAvatar;
